var $grid = $('.grid').isotope({
  itemSelector: '.grid-item',
  layoutMode: 'fitRows',
});

// layout Isotope after each image loads
$grid.imagesLoaded().progress( function() {
  $grid.isotope('layout');
});



// filter items on button click
$('.tag-btn').on('click', function() {

  var filterValue = $(this).attr('data-filter');
  $grid.isotope({ filter: filterValue });

});


// change is-checked class on buttons
var tagItem = $('.moduleGallery ul.tags li');
tagItem.each( function(i, buttonGroup) {
	var active = $(this);

  $(this).on('click','button', function() {
    tagItem.removeClass('active');
    active.addClass('active');
  });
});